export const TAG_FORECAST_CONFIG = 'FORECAST_CONFIG'
export const TAG_FORECAST_REGIONS = 'TAG_FORECAST_REGIONS'
export const TAG_FORECAST_SCENARIOS = 'TAG_FORECAST_SCENARIOS'

export default [TAG_FORECAST_CONFIG, TAG_FORECAST_REGIONS, TAG_FORECAST_SCENARIOS]
